<template>
  <div
    class="sample-table"
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-text="正在设计中..."
  >
    <img src="@/assets/images/logo.png" width="8%" />
    <img src="@/assets/images/email_link_head.png" width="100%" />
    <div class="contain" v-if="isItInvalid == true">
      <div class="lose-efficacy-tips">
        <i class="el-icon-warning" style="color:#00A7F0;font-size:20px"></i>
        此页面链接有效期至{{expireTimeShow}}，到期后该链接自动失效，到期后如需继续设计引物，请联系客服人员。
      </div>
      <h2 style="text-align:center;padding-bottom:20px;">扩增引物设计</h2>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="130px"
        class="demo-form"
      >
        <el-form-item label="目的序列：" prop="sequence">
          <el-input
            type="textarea"
            maxlength="20000"
            :rows="5"
            v-model="form.sequence"
            show-word-limit
            placeholder="支持输入ATCG，最多输入20000个字"
            @input="handlerIpt"
          ></el-input>
        </el-form-item>
        <el-form-item label="扩增开始位置：" prop="amplificationStartPosition">
          <el-input
            v-model="form.amplificationStartPosition"
            placeholder="请填写扩增区域的开始位置，只能填写整数"
          ></el-input>
        </el-form-item>
        <el-form-item label="扩增结束位置：" prop="amplificationEndPosition">
          <el-input
            v-model="form.amplificationEndPosition"
            placeholder="请填写扩增区域的结束位置，只能填写整数"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="width: 100%;text-align: center;">
        <el-button
          type="primary"
          @click="handlerDesignPrimers()"
          style="padding: 10px 40px"
          >设计引物</el-button
        >
      </div>
      <div class="title-front" v-if="hotSettings.data.length">
        设计结果：
      </div>
      <div
        style="display:flex;margin-bottom:50px;"
        v-if="hotSettings.data.length"
      >
        <div style="width:100%;height:300px;overflow: auto">
          <HotTable ref="htTableRef" style="" :settings="hotSettings" />
        </div>
      </div>
      <div
        style="width: 100%;text-align: center;"
        v-if="hotSettings.data.length"
      >
        <el-button type="primary" @click="handlerSubmit()"
          >下单合成引物</el-button
        >
      </div>
    </div>
    <div v-if="isItInvalid == false" class="link_failure">
      <img src="@/assets/images/link_failure.png" width="4%" />
      <p style="font-size:30px;padding-top: 20px;font-weight:bold">
        链接已失效
      </p>
      <p style="font-size:20px;padding-top: 20px;">
        此页面链接已失效，如果您需要设计引物，请联系客服人员！
      </p>
    </div>
  </div>
</template>
<script>
import { HotTable } from "@handsontable-pro/vue";
import "handsontable-pro/dist/handsontable.full.css";
import {
  primersDesign,
  designPrimerEncVo,
  customerClcikEvent
} from "@/services/api.index";
export default {
  components: {
    HotTable
  },
  data() {
    return {
      isItInvalid: null,
      loading: false,
      tableData: [],
      form: {
        sequence: "",
        amplificationStartPosition: "",
        hashKey: "",
        amplificationEndPosition: ""
      },
      sjywBurialPointHashKey: "",
      xdhcywBurialPointHashKey: "",
      rules: {
        sequence: [
          { required: true, message: "必填项不可为空", trigger: "change" },
          { validator: this.checkConcentration, trigger: "change" }
        ],
        amplificationStartPosition: [
          { required: true, message: "必填项不可为空", trigger: "change" },
          {
            validator: this.checkAmplificationPosition,
            trigger: "change"
          }
        ],
        amplificationEndPosition: [
          { required: true, message: "必填项不可为空", trigger: "change" },
          {
            validator: this.checkAmplificationPosition,
            trigger: "change"
          }
        ]
      },
      hotSettings: {
        width: "auto",
        autoRowSize: true,
        stretchH: "all", // 均匀调整列宽
        data: [],
        colWidths: [15, 30, 40, 120],
        columns: [
          { type: "checkbox", data: "checkbox" },
          {
            data: "number",
            title: "片段序号",
            readOnly: true
          },
          {
            data: "primer",
            title: "引物",
            readOnly: true
          },
          {
            data: "sequence",
            title: "序列",
            readOnly: true
          },
          {
            data: "tmValue",
            title: "Tm值"
          },
          {
            data: "gc",
            title: "GC含量"
          },
          {
            data: "CardIssuingStructure",
            title: "发卡结构"
          },
          {
            data: "position",
            title: "位置"
          },
          {
            data: "fragmentLength",
            title: "片段大小"
          },
          {
            data: "remark",
            title: "备注"
          }
        ]
      },
      expireTimeShow: ""
    };
  },
  async created() {
    const { info } = this.$route.query;
    await designPrimerEncVo(info).then(({ data }) => {
      const now = new Date(this.baseMethods.dateToString("", "-")).getTime();
      this.expireTimeShow = this.baseMethods.dateToStringChinese(data.expireTime);
      const expireTime = new Date(data.expireTime).getTime();
      if (expireTime >= now) {
        this.isItInvalid = true;
      } else {
        this.isItInvalid = false;
        return false;
      }
      this.sjywBurialPointHashKey = data.sjywBurialPointHashKey;
      this.xdhcywBurialPointHashKey = data.xdhcywBurialPointHashKey;
    });
  },
  methods: {
    async handlerDesignPrimers() {
      customerClcikEvent(this.sjywBurialPointHashKey);
      await this.handlerPrimers();
      this.form.hashKey = this.sjywBurialPointHashKey;
      this.loading = true;
      this.hotSettings.data = [];
      primersDesign(this.form)
        .then(({ data }) => {
          data.map(v => {
            this.hotSettings.data.push(v);
          });
          this.mergeCellsHandler();
          this.loading = false;
          this.$message.success("设计完成");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    mergeCellsHandler() {
      this.hotSettings.mergeCells = [];
      for (let i = 0; i < this.hotSettings.data.length - 1; i += 2) {
        this.hotSettings.mergeCells.push(
          { row: i, col: 0, rowspan: 2, colspan: 1 },
          { row: i, col: 1, rowspan: 2, colspan: 1 },
          { row: i, col: 8, rowspan: 2, colspan: 1 }
        );
      }
    },
    checkAmplificationPosition(rule, val, callback) {
      let reg = /^[0-9]\d*$/;
      if (reg.test(val)) {
        callback();
      } else {
        callback("扩增区域格式错误");
      }
    },
    checkConcentration(rule, val, callback) {
      // 验证引物序列输入
      const validText = val => {
        let str = "ATCG";
        if (!val || val === "") return;
        let tempArr =
          val &&
          val.split("").map(k => {
            return str.indexOf(k) > -1;
          });

        return tempArr.some(v => !v);
      };
      val = val ? val.replace(/\s/g, "") : val;
      let bool = validText(val);
      if (!bool) return callback();
      return callback(new Error("支持输入ATCG"));
    },
    async handlerSubmit() {
      customerClcikEvent(this.xdhcywBurialPointHashKey);
      this.hotSettings.data.forEach((v, idx) => {
        this.hotSettings.data.forEach((e, i) => {
          if (v.number === e.number && i !== idx) {
            if (v.checkbox) {
              e.checkbox = true;
            }else {
              e.checkbox = false;
            }
          }
        });
      });
      const checkboxs = this.hotSettings.data.filter((v, i) => v.checkbox);
      if (!checkboxs.length) return this.$message.warning("请选择要合成的引物");
      const routeUrl = this.$router.resolve({
        name: "OrderPrimer",
        query: { isPrimerlayout: true }
      });
      window.open(routeUrl.href, "_blank");
      this.baseMethods.setLocalObj("checkboxsOrderPrimers", checkboxs);
    },
    handlerPrimers() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(async valid => {
          if (valid) {
            resolve(this.form);
          } else {
            // this.$message.warning("必填项不可为空");
            reject();
          }
        });
      });
    },
    handlerIpt(event) {
			this.form.sequence = event.toUpperCase();
		},
  }
};
</script>

<style lang="scss" scpoed>
.contain {
  width: 100%;
  padding: 10px 300px;
  position: relative;
}
.tips {
  color: #d9001b;
}
.el-icon-loading:before {
  content: "\E6CF";
  font-size: 40px;
  font-weight: bold;
}

.lose-efficacy-tips {
  padding-bottom: 20px;
  background-color: #f6fafd;
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}
.title-front {
  border-left: 4px solid #014492;
  padding: 0 5px;
  margin-bottom: 10px;
}
.link_failure {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
}
</style>

<style lang="scss">
.contain {
  .handsontable thead {
    background-color: #f6fafd;
  }
  .handsontable .htDimmed {
    background-color: #f6fafd;
  }
  .handsontable thead {
    td,
    th {
      background-color: #f6fafd;
    }
  }
  #hot-display-license-info {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EmailLink/amplificationPrimerDesign.vue